import { ElementType } from "react"
import { Box, Grid } from "@mui/material";
import { useContext } from "react";
import { TrainingsContext } from "@my-helpers/common";
import { 
    TrainingAdditionalInfo, 
    TrainingBasicInfo, 
    TrainingHeader,
    TrainingDetail
} from "@/components/training";
import { useTheme } from "@mui/material";

export const TrainingView: ElementType = () => {
    const context = useContext(TrainingsContext);
    if (!context) {
        throw new Error('TrainingsContext not found');
    }
    const { view, command } = context;
    const { currentTraining } = view;
    const { refreshTraining } = command;
    const theme = useTheme();

	return (
		<Box sx={{
            height: '100vh',
            display: 'flex',
            flexDirection: 'column',
            p: theme.spacing(3),
        }}>
            <TrainingHeader
                currentTraining={currentTraining}
                refreshTraining={refreshTraining}
            />
            <Grid container spacing={2}>
                <Grid size={4}>
                    <TrainingBasicInfo training={currentTraining} />
                </Grid>
                <Grid size={4}>
                    <TrainingDetail training={currentTraining} />
                </Grid>
                <Grid size={4}>
                    <TrainingAdditionalInfo />
                </Grid>
            </Grid>
        </Box>
	)
}

export default TrainingView;